import { FEATURE_NAME } from "@/components/LicenseGuard/LicenseGuard.constant";
import { useHasLicenseAccess } from "@/components/LicenseGuard/useHasLicenseAccess";
import { useGetFeaturesFlags } from "@/hooks/useGetFeaturesFlags/useGetFeaturesFlags";

export function useHasSentimentAnalysis(): boolean {
  const featureFlags = useGetFeaturesFlags();
  const hasLicenseAccess = useHasLicenseAccess({
    feature: FEATURE_NAME.AI_STANDARD_ACCESS,
  });

  if (featureFlags?.conversationCenterDisableSentiments) {
    return false;
  }

  return hasLicenseAccess;
}
